import { render } from "./opSelect.vue?vue&type=template&id=542bb540&scoped=true&ts=true"
import script from "./opSelect.vue?vue&type=script&lang=ts"
export * from "./opSelect.vue?vue&type=script&lang=ts"

import "./opSelect.vue?vue&type=style&index=0&id=542bb540&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542bb540"]])

export default __exports__